module.exports = __webpack_public_path__ + "img/link-download-rw-hover.80453ed8.svg";